import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Link, StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import { Navigation } from '.'
import config from '../../utils/siteConfig'

// Styles
import '../../styles/app.css'

/**
 * Main layout component
 *
 * The Layout component wraps around each page and tmeplate.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */
const DefaultLayout = ({ data, children, bodyClass, isHome }) => {
    const site = data.allGhostSettings.edges[0].node
    const twitterUrl = site.twitter ? `https://twitter.com/${site.twitter.replace(/^@/, ``)}` : null
    const facebookUrl = site.facebook ? `https://www.facebook.com/${site.facebook.replace(/^\//, ``)}` : null

    return (
    <>
        <Helmet>
            <html lang={site.lang} />
            <body className={bodyClass} />
        </Helmet>

        <div className="viewport">

            <div className="viewport-top">
                {/* The main header section on top of the screen */}
                <header className="site-head">
                    <div className="container">
                        <div className="site-mast">
                            <div className="site-mast-left">
                                <a href="https://www.omnicalculator.com">
                                    <svg fill="white" viewBox="0 0 2399 220">
                                        <title>Omni Calculator logo</title>
                                        <path d="M1062.3 91.2c-7.5-3.3-15.3-5-23.3-5-10.5 0-20.2 2.6-29 7.7s-15.8 12.1-20.9 20.8c-5.1 8.8-7.7 18.4-7.7 28.9 0 10.4 2.6 20 7.7 28.8s12.1 15.8 20.9 20.9 18.5 7.7 29 7.7c7.8 0 15.5-1.6 23.1-4.8 7.5-3.2 14.2-7.6 20.1-13.1l12.4 13.5c-7.5 7.4-16.3 13.2-26.3 17.4-10 4.2-20.1 6.3-30.3 6.3-14.2 0-27.3-3.4-39.1-10.1-11.8-6.8-21.1-16-28-27.6-6.8-11.7-10.2-24.6-10.2-38.6 0-13.9 3.4-26.7 10.4-38.3 6.9-11.6 16.3-20.7 28.3-27.4 12-6.7 25.1-10 39.5-10 10.4 0 20.5 2 30.2 5.9 9.7 3.9 18.2 9.4 25.3 16.5l-12.2 14.7c-5.7-6.2-12.3-10.8-19.9-14.2zm175.3 127.6l-15.8-36.3H1143l-15.6 36.3h-21.6l66.4-149.5h21.4l66.2 149.5h-22.2zm-86.5-54.9h62.8l-31.6-72.6-31.2 72.6zm134.8-94.5h20.5v130.9h65.3v18.6h-85.8V69.4zm204.5 21.8c-7.5-3.3-15.3-5-23.3-5-10.5 0-20.2 2.6-29 7.7s-15.8 12.1-20.9 20.8c-5.1 8.8-7.7 18.4-7.7 28.9 0 10.4 2.6 20 7.7 28.8s12.1 15.8 20.9 20.9c8.8 5.1 18.5 7.7 29 7.7 7.8 0 15.5-1.6 23.1-4.8 7.5-3.2 14.2-7.6 20.1-13.1l12.4 13.5c-7.5 7.4-16.3 13.2-26.3 17.4-10 4.2-20.1 6.3-30.3 6.3-14.2 0-27.3-3.4-39.1-10.1-11.8-6.8-21.1-16-28-27.6-6.8-11.7-10.2-24.6-10.2-38.6 0-13.9 3.4-26.7 10.4-38.3 6.9-11.6 16.3-20.7 28.3-27.4 12-6.7 25.1-10 39.5-10 10.4 0 20.5 2 30.2 5.9 9.7 3.9 18.2 9.4 25.3 16.5l-12.2 14.7c-5.7-6.2-12.3-10.8-19.9-14.2zm93.9 98.9c7.6 7.8 18.1 11.6 31.5 11.6 13.2 0 23.6-3.9 31.2-11.6 7.5-7.8 11.3-18.5 11.3-32.3V69.4h20.5v88.4c0 19.5-5.6 34.8-16.8 45.9-11.2 11.1-26.6 16.7-46.2 16.7-19.8 0-35.3-5.6-46.5-16.7-11.2-11.1-16.9-26.4-16.9-45.9V69.4h20.5v88.4c-.1 13.8 3.7 24.5 11.4 32.3zm138.2-120.7h20.5v130.9h65.3v18.6h-85.8V69.4zm228.7 149.4l-15.8-36.3h-78.8l-15.6 36.3h-21.6l66.4-149.5h21.4l66.2 149.5h-22.2zm-86.5-54.9h62.8l-31.6-72.6-31.2 72.6zm101.2-94.5h116.8v18.8h-48.3v130.7h-20.5V88.1h-48V69.4zm240.1 8.7c12 6.7 21.5 15.8 28.5 27.4 7 11.6 10.5 24.4 10.5 38.3 0 14-3.5 26.8-10.5 38.5s-16.5 21-28.5 27.8c-12 6.8-25.2 10.1-39.6 10.1-14.4 0-27.6-3.4-39.6-10.1-12-6.8-21.5-16-28.5-27.8-7-11.7-10.5-24.6-10.5-38.5 0-13.9 3.5-26.7 10.5-38.3 7-11.6 16.4-20.7 28.4-27.4 12-6.7 25.2-10 39.7-10 14.4 0 27.6 3.3 39.6 10zm-68.3 16c-8.9 5.1-16 12.1-21.2 20.8-5.3 8.8-7.9 18.4-7.9 28.9s2.6 20.2 7.9 29c5.3 8.8 12.3 15.8 21.2 21 8.9 5.2 18.5 7.8 28.9 7.8 10.4 0 20-2.6 28.7-7.8 8.8-5.2 15.7-12.2 20.9-21 5.2-8.8 7.8-18.5 7.8-29s-2.6-20.2-7.8-28.9c-5.2-8.8-12.2-15.7-20.9-20.8-8.8-5.1-18.3-7.7-28.7-7.7-10.4 0-20 2.6-28.9 7.7zm237.5 124.7l-29.7-47c-3.4.3-6.2.4-8.3.4h-38v46.5h-20.5V69.4h58.5c18.9 0 33.6 4.4 43.9 13.1 10.3 8.8 15.5 21.2 15.5 37.3 0 12.1-2.8 22.3-8.4 30.5-5.6 8.3-13.7 14.2-24.2 17.9l34.8 50.6h-23.6zm-38-65.1c12.8 0 22.6-2.8 29.5-8.4 6.8-5.6 10.2-13.9 10.2-24.9 0-10.7-3.4-18.8-10.2-24.2-6.8-5.5-16.7-8.2-29.5-8.2h-38v65.8h38zM768.8 206.8V57.5c0-6.6-5.4-12-12-12h-35.7c-6.6 0-12 5.4-12 12v149.3c0 6.6 5.4 12 12 12h35.7c6.7 0 12-5.4 12-12zM92.3 218.6C41.4 218.6 0 177.2 0 126.3S41.4 34 92.3 34s92.3 41.4 92.3 92.3-41.4 92.3-92.3 92.3zm0-126.2c-18.7 0-33.9 15.2-33.9 33.9s15.2 33.9 33.9 33.9 33.9-15.2 33.9-33.9S111 92.4 92.3 92.4z" />
                                        <circle cx="843" cy="33.9" r="33.9" />
                                        <path d="M569 206.8l-.2-118.9c.7-.5 1.6-1.5 4.5-2s5.6-.7 8.2-.7c9.5 0 16 1.7 20.6 7 4.6 5.3 7 14.1 7 26.4l.2 88.1c0 6.6 5.4 11.9 12 11.9H657c6.6 0 12-5.4 12-12l-.2-93.8c0-17.2-2.6-31-7.8-41.4-5.2-10.4-11.9-18.4-20.2-24-8.2-5.6-17.5-9.2-27.7-11-10.2-1.7-20.4-2.6-30.6-2.6-17.4 0-31.9 1.3-43.5 4-7.7 1.8-14.6 3.5-20.7 5.4-5.3 1.6-8.9 6.4-8.9 11.9v151.5c0 6.6 5.4 12 12 12H557c6.7.2 12-5.2 12-11.8zM461.5 72c-5.1-10.6-11.5-18.7-19.4-24.4-7.9-5.7-16.7-9.4-26.5-11.1-9.8-1.8-19.2-2.6-28.4-2.6-10.4 0-19.7 1.2-27.9 3.5-8.2 2.4-15.4 5.1-21.5 8.1-8-4.7-16.7-7.8-26.1-9.4-9.4-1.5-19-2.3-28.6-2.3-17.7 0-32.2 1.4-43.8 4.1-7.8 1.8-14.8 3.7-21.1 5.6a12 12 0 0 0-8.6 11.5v151.8c0 6.6 5.4 12 12 12h35.7c6.6 0 12-5.4 12-12V87.5c.7-.5 2.5-.9 5.5-1.4 2.9-.5 5.7-.7 8.3-.7 9.6 0 16.5 2.7 20.5 8.1 4 5.4 6 14.4 6 26.8v86.4c0 6.6 5.4 12 12 12h35.7c6.6 0 12-5.4 12-12V87.2c1-.2 2.1-.5 3.4-.8 3.2-.7 6.4-1.1 9.7-1.1 9.6 0 16.6 2.7 20.8 8.1 4.2 5.4 6.4 14.4 6.4 26.8v86.4c0 6.6 5.4 12 12 12h35.7c6.6 0 12-5.4 12-12v-92.8c-.2-17.2-2.7-31.2-7.8-41.8z" />
                                    </svg>
                                </a>
                            </div>
                            <div className="site-mast-right">
                                { site.twitter && <a href={ twitterUrl } className="site-nav-item" target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src={`/images/icons/twitter.svg`} alt="Twitter" /></a>}
                                { site.facebook && <a href={ facebookUrl } className="site-nav-item" target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src={`/images/icons/facebook.svg`} alt="Facebook" /></a>}
                                <a className="site-nav-item" href="https://www.omnicalculator.com/blog/rss" target="_blank" rel="noopener noreferrer"><img className="site-nav-icon" src={`/images/icons/rss.svg`} alt="RSS Feed" /></a>
                            </div>
                        </div>
                        { isHome ?
                            <div className="site-banner">
                                <h1 className="site-banner-title">{site.title}</h1>
                                <p className="site-banner-desc">{site.description}</p>
                            </div> :
                            null}
                        <nav className="site-nav">
                            <div className="site-nav-left">
                                {/* The navigation items as setup in Ghost */}
                                <Navigation data={site.navigation} navClass="site-nav-item" />
                            </div>
                            <div className="site-nav-right">
                                <Link className="site-nav-button" to="/">Omni Blog</Link>
                            </div>
                        </nav>
                    </div>
                </header>

                <main className="site-main">
                    {/* All the main content gets inserted here, index.js, post.js */}
                    {children}
                </main>

            </div>

            <div className="viewport-bottom">
                {/* The footer at the very bottom of the screen */}
                <footer className="site-foot">
                    <div className="site-foot-nav container">
                        <div className="site-foot-nav-left">
                            <Link to="/">{site.title}</Link> © 2019
                        </div>
                        <div className="site-foot-nav-right">
                            <Navigation data={site.navigation} navClass="site-foot-nav-item" />
                        </div>
                    </div>
                </footer>

            </div>
        </div>

    </>
    )
}

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    bodyClass: PropTypes.string,
    isHome: PropTypes.bool,
    data: PropTypes.shape({
        allGhostSettings: PropTypes.object.isRequired,
    }).isRequired,
}

const DefaultLayoutSettingsQuery = props => (
    <StaticQuery
        query={graphql`
            query GhostSettings {
                allGhostSettings {
                    edges {
                        node {
                            ...GhostSettingsFields
                        }
                    }
                }
                file(relativePath: {eq: "ghost-icon.png"}) {
                    childImageSharp {
                        fixed(width: 30, height: 30) {
                            ...GatsbyImageSharpFixed
                        }
                    }
                }
            }
        `}
        render={data => <DefaultLayout data={data} {...props} />}
    />
)

export default DefaultLayoutSettingsQuery
